import './App.css';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ProtectedBrowser from './protected-browser';
import { GlobalProvider } from './context/global-provider';
import { AdminProvider } from './context/admin-provider';
import { ChakraProvider } from '@chakra-ui/react';
import NotFound from './pages/status-page/not-found';
import Error from './pages/status-page/error';
import { lazy, Suspense, useEffect, useRef } from 'react';
import Loading from './components/loading';
import { ToastContainer } from 'react-toastify';
import AdminGuard from './pages/admin/components/admin-guard';

const Welcome = lazy(() => import('./pages/welcome'));
const Login = lazy(() => import('./pages/login'));
const Start = lazy(() => import('./pages/start'));
const Instruction = lazy(() => import('./pages/instruction'));
const TestList = lazy(() => import('./pages/test-list'));
const ThankYou = lazy(() => import('./pages/thank-you'));

const AdminLogin = lazy(() => import('./pages/admin/admin-login'));
const AdminActivities = lazy(() => import('./pages/admin/admin-activities'));

export default function App() {
  const appRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    console.log(
      '%cWARNING!',
      'color: red; font-size: 50px; font-weight: bold; text-shadow: 2px 2px 0 black, 4px 4px 0 black;'
    );
    console.log(
      '%cDo not enter or paste any code here. It may be used to steal your data.',
      'color: red; font-size: 20px;'
    );
  }, []);

  return (
    <div ref={appRef}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Routes>
          <Route
            path="/admin/login"
            element={
              <Suspense fallback={<Loading />}>
                <AdminLogin />
              </Suspense>
            }
          />
          <Route
            path="/admin/activities"
            element={
              <AdminGuard>
                <AdminProvider>
                  <Suspense fallback={<Loading />}>
                    <AdminActivities />
                  </Suspense>
                </AdminProvider>
              </AdminGuard>
            }
          />

          <Route
            path="/*"
            element={
              <ProtectedBrowser>
                <GlobalProvider>
                  <ChakraProvider resetCSS={false}>
                    <Routes>
                      <Route path="*" element={<NotFound />} />
                      <Route path="/error" element={<Error />} />

                      <Route
                        path="/welcome"
                        element={
                          <Suspense fallback={<Loading />}>
                            <Welcome />
                          </Suspense>
                        }
                      />

                      <Route
                        path="/start"
                        element={
                          <Suspense fallback={<Loading />}>
                            <Start />
                          </Suspense>
                        }
                      />

                      <Route
                        path="/"
                        element={
                          <Suspense fallback={<Loading />}>
                            <Login />
                          </Suspense>
                        }
                      />

                      <Route
                        path="/instruction"
                        element={
                          <Suspense fallback={<Loading />}>
                            <Instruction />
                          </Suspense>
                        }
                      />

                      <Route
                        path="/test-list"
                        element={
                          <Suspense fallback={<Loading />}>
                            <TestList />
                          </Suspense>
                        }
                      />

                      <Route
                        path="/thankyou"
                        element={
                          <Suspense fallback={<Loading />}>
                            <ThankYou />
                          </Suspense>
                        }
                      />
                    </Routes>
                  </ChakraProvider>
                </GlobalProvider>
              </ProtectedBrowser>
            }
          />
        </Routes>
      </BrowserRouter>

      <ToastContainer />
    </div>
  );
}
